import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { LoadNewPlans } from "../../actions";
import { RefreshCircleIcon } from "../../icon";
import { Plan, PlanType } from "../../models/plans.model";
import * as selector from "../../selectors/selectors";
import { appNote, buttonLabels, tenureTexts } from "../shared/constants";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import TierLoader from "../shared/loaders/tiers-loader.json";
import NewPlanCard from "../new-subscription-flow/NewPlanCard";
import ButtonComponent from "../shared/button/button.component";
import { RechargeStatus } from "../../models/transaction-history.model";
import { OrganizationService } from "../../services/OrganizationService";
import { mapToSeatUsage, SeatUsage } from "../../models/organization.model";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";

interface IProps {
    IsManualPayment?: boolean;
    onSelectPlan: (data: { Plan: Plan, Tenure: string, Count: number }) => void;
    Stepdata?: any;
}

const NewSelectPlan = (props: IProps) => {
    const dispatch = useDispatch()
    const { state } = useLocation();
    const Plans: Plan[] = useSelector(selector.newPlans)
    const LoadingPlans: boolean = useSelector(selector.loadingNewPlans)
    const LoadingFeatures: boolean = useSelector(selector.loadingFeatures)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const [selectSheet, setSelectedSheet] = useState<Array<{ id: string, count: number, isTouched: boolean }>>([]);
    const [seats, setSeats] = useState<SeatUsage[]>([])

    const [tenure, setTenure] = useState<number>((!props.Stepdata?.planHistory?.length || props.Stepdata?.planHistory[0].IsYearPlan === true || state.Organization?.IsYearPlan === null) ? 1 : 2);

    const handleTabChange = (event: any, tabs: any) => {
        if (tabs !== null) {
            setTenure(tabs)
        }
    }

    const onSelectionChange = (id: string, count: number) => {
        const existing = selectSheet?.find(x => x.id === id);
        if (existing) {
            let plan = props.Stepdata?.planHistory.filter((x) => x.StatusType === RechargeStatus.ONGOING).find((x) => x.PlanId === id)
            if (!plan) {
                setSelectedSheet(selectSheet.map(x => x.id === id ? { ...x, count: count, isTouched: true } : x).filter(x => x.count > 0));
            }
            else {
                let seat = seats?.find(x => x.PlanId === id)
                if (!!seat && seat?.Users?.Used > count) {
                    setToast("You cannot reduce the seat quantity because all purchased seats are currently assigned. Please remove assigned users before decreasing the seat count.", ToasterType.DANGER, 30)
                    return
                }
                setSelectedSheet(selectSheet.map(x => x.id === id ? { ...x, count: count, isTouched: plan.Quantity !== count ? true : false } : x));
            }
        } else {
            setSelectedSheet([...selectSheet, { id, count: count, isTouched: true }]);
        }
    }

    const handleconfirm = () => {
        const selectedPlansWithDetails = selectSheet.filter((x) => x.isTouched).map(sheet => {
            const planDetails = Plans.find(plan => plan.Id === sheet.id);
            return {
                Plan: planDetails,
                Count: sheet.count
            };
        }).filter(x => x.Plan);

        // Example: If you only allow one selection and want to pass it to props.onSelectPlan
        if (selectedPlansWithDetails.length === 1) {
            props.onSelectPlan({
                Plan: selectedPlansWithDetails[0].Plan,
                Tenure: tenure === 1 ? "A" : "M",
                Count: selectedPlansWithDetails[0].Count
            });
        };
    }

    const getSeatDetails = (id: string) => {
        OrganizationService.getSeatDetails(id)
            .then(res => {
                let seats = res.data.seatUsage.map(mapToSeatUsage)
                setSeats(seats)
            }).catch(err => {
                // Handle error if needed
            });
    }

    useEffect(() => {
        LoadNewPlans(dispatch)
        getSeatDetails(state.OrganizationId)
    }, [])

    useEffect(() => {
        let data = props.Stepdata?.planHistory.filter((x) => x.StatusType === RechargeStatus.ONGOING).map(({ PlanId, Quantity }) => {
            return {
                id: PlanId,
                count: Quantity,
                isTouched: false
            };
        });
        setSelectedSheet(data ?? [])
        setTenure((!props.Stepdata?.planHistory?.length || props.Stepdata?.planHistory[0]?.IsYearPlan === true || state.Organization?.IsYearPlan === null) ? 1 : 2)
    }, [props.Stepdata?.planHistory])


    return (
        <Grid container className=" ml-2 mr-2 h-v-80 paper-background  dialogue-shadow settings-paper-border br-4">
            {!state.IsAddonRecharge &&
                <div className={`w-fill pt-1 pr-2`}>
                    <Grid container className={` d-flex justify-flex-end  ${(IsMobileDevice) ? 'pr-3' : ''} `}>
                        <ToggleButtonGroup value={[tenure]} exclusive disabled={!!props.Stepdata?.planHistory?.length} className={`bg-color-secondary br-5 dialogue-shadow settings-paper-border`} onChange={handleTabChange}>
                            <ToggleButton value={1} size='small' className={`${tenure === 1 ? "plans-button-active plans-button" : "plans-button"} ${IsMobileDevice ? 'h2' : 'h4-regular'} butons-transform  br-6 b-none`}  > {tenureTexts.ANNUAL}</ToggleButton>
                            <ToggleButton value={2} size="small" className={`${tenure === 2 ? "plans-button-active plans-button" : "plans-button"} ${IsMobileDevice ? 'h2' : 'h4-regular'} b-none br-6 butons-transform`} style={{ marginLeft: '0.01rem' }}>{tenureTexts.MONTH}</ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>

                </div>
            }
            <Grid container direction="row" className={`mx-0 d-flex justify-center align-center h-p-80 o-y-scroll o-x-hidden`} >
                {LoadingPlans || LoadingFeatures ?
                    <Grid xl={3} md={6} sm={8} item className='my-2 mx-4'>
                        <AnimateLoader LoaderAnimation={TierLoader} style={{ maxWidth: "330px" }} className={"w-p-100"} />
                    </Grid>
                    : Plans?.filter(x => !x.IsDeleted && x.PlanType === PlanType.TIER).length > 0 ?
                        Plans?.filter(x => !x.IsDeleted && x.PlanType === PlanType.TIER).length ? Plans.filter(x => !x.IsDeleted && x.PlanType === PlanType.TIER).map((plan, i) =>
                            <Grid item>
                                <NewPlanCard
                                    key={plan.Id}
                                    Index={i}
                                    Plan={plan}
                                    ShowAddOnOptions={false}
                                    SelectionCount={(selectSheet.filter((x) => x.id === plan.Id)[0]?.count || 0)}
                                    OnSelectionChange={(count) => { onSelectionChange(plan.Id, count) }}
                                    PlanSelected={selectSheet.filter(x => x.isTouched)?.length > 0 && (selectSheet.filter(x => x.id === plan.Id)?.length > 0 ? false : true)}
                                    HideBuyNow={true}
                                    DisplayYearlyPrice={tenure === 1}
                                    EnableCounter={(!selectSheet.filter(x => x.isTouched)?.length || selectSheet.filter((x) => x.id === plan.Id)[0]?.isTouched) ?? false}
                                />
                            </Grid>)
                            :
                            <span className="h3-regular">{"No plans available"}</span>
                        : <div className="c-pointer" onClick={() => LoadNewPlans(dispatch)}>
                            <div className="d-flex">
                                <RefreshCircleIcon className="mx-auto" />
                            </div>
                            <div className="h4 mt-1">{appNote.CLICK_TO_REFRESH_PLANS}</div>
                        </div>
                }
            </Grid>
            <Grid container direction="row" className="d-flex justify-end align-center" justifyContent="flex-end">
                <ButtonComponent OnClick={() => handleconfirm()} ButtonLabel={buttonLabels.CONFIRM} ClassName={"c-pointer mr-2"} Variant={selectSheet.filter(x => x.isTouched)?.length > 0 ? "primary-btn-small" : "disabled-btn-small"} />
            </Grid>
        </Grid >)
};

export default NewSelectPlan;